import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../../Panel';
import styles from './ElevationFilter.module.scss';
import { connect } from 'dva';
import noop from 'lodash-es/noop';
import { MAP_LAYER_IDS, MAP_MODES } from '../../../../lib/constants';
import { prettyNumber } from '../../../../lib/utils';
import Slider from '../../../Form/Slider';

export function ElevationFilter(props) {
  return (
    <Panel title='Elevation' divider={true}>
      <div className={styles.rangeContainer}>
        <Slider
          disabled={!props.toolEnabled}
          max={14400}
          min={100}
          showLabel={true}
          step={100}
          value={props.elevationValues}
          onAfterChange={props.onChange}
          // onChange={props.is3d ? noop : props.onChange}
          labelFormatter={(thumbProps, state) => {
            return `${prettyNumber(state.valueNow, 0)} ft.`;
          }}
        />
      </div>
    </Panel>
  );
}

ElevationFilter.propTypes = {
  elevationLayer: PropTypes.object,
  elevationValues: PropTypes.array,
  is3d: PropTypes.bool,
  onChange: PropTypes.func,
  toolEnabled: PropTypes.bool,
};

export default connect((model) => {
  return {
    // aspectEnabled: model.terrain.enabledTools.includes('aspect'),
    elevationLayer: model.map.mapRef.findLayerById(MAP_LAYER_IDS.terrainAnalysis),
    is3d: model.map.mapMode === MAP_MODES.ThreeD,
    // slopeEnabled: model.terrain.enabledTools.includes('slope'),
    toolEnabled: model.terrain.preferences.terrainAnalysis.enabled,
  };
})(ElevationFilter);
